import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import HomeScreenLayoutEditor, { collectLayoutBundleIds } from "../profileEditor/HomeScreenLayoutEditor";
import "../../pages/profileEditor.css";

const emptyLayout = { Dock: [], Pages: [[]] };

function collectWebClipsFromLayout(layout, existing = []) {
  const byUrl = new Map();
  for (const clip of existing || []) {
    const url = String(clip?.URL || "").trim();
    if (url) byUrl.set(url, { Label: clip.Label || url, URL: url });
  }
  const visit = (entry) => {
    if (!entry) return;
    if (entry.Type === "WebClip" && entry.URL) {
      const url = String(entry.URL).trim();
      if (!url) return;
      if (!byUrl.has(url)) byUrl.set(url, { Label: entry.Label || url, URL: url });
    }
    if (entry.Type === "Folder") {
      for (const page of entry.Pages || []) {
        for (const child of page || []) visit(child);
      }
    }
  };
  for (const item of layout?.Dock || []) visit(item);
  for (const page of layout?.Pages || []) {
    for (const item of page || []) visit(item);
  }
  return [...byUrl.values()];
}

export default function ClassroomLayoutModal({
  open,
  value,
  webClips: initialWebClips = [],
  installedApps = [],
  onClose,
  onApply,
}) {
  const [fields, setFields] = useState(emptyLayout);
  const [webClips, setWebClips] = useState([]);
  const [clipLabel, setClipLabel] = useState("");
  const [clipUrl, setClipUrl] = useState("");

  useEffect(() => {
    if (!open) return;
    if (value?.Pages) setFields({ Dock: value.Dock || [], Pages: value.Pages });
    else setFields(emptyLayout);
    setWebClips(Array.isArray(initialWebClips) ? initialWebClips.filter((c) => c?.URL) : []);
    setClipLabel("");
    setClipUrl("");
  }, [open, value, initialWebClips]);

  const addWebClip = () => {
    const url = clipUrl.trim();
    if (!url) return;
    const label = clipLabel.trim() || url;
    setWebClips((prev) => {
      const without = prev.filter((c) => c.URL !== url);
      return [...without, { Label: label, URL: url }];
    });
    setClipLabel("");
    setClipUrl("");
  };

  const removeWebClip = (url) => {
    setWebClips((prev) => prev.filter((c) => c.URL !== url));
  };

  if (!open) return null;

  return (
    <div className="teacher-modal-backdrop" role="dialog" aria-modal="true">
      <div className="teacher-modal teacher-modal--wide teacher-modal--layout">
        <div className="teacher-modal__head">
          <h3>Homescreen-Layout</h3>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose} aria-label="Schließen">
            <FaTimes />
          </button>
        </div>
        <p className="small text-muted px-3 mb-0">
          Apps und Webclips platzieren. Beim Anwenden wird die Allowlist anhand des Layouts gesetzt
          (inkl. Einstellungen), die Blacklist entsprechend zurückgenommen.
        </p>
        <div className="teacher-modal__body teacher-modal__body--layout">
          <div className="teacher-layout-webclips mb-3">
            <h4 className="h6 mb-2">Webclips erstellen</h4>
            <div className="d-flex flex-wrap gap-2 align-items-end mb-2">
              <label className="small mb-0">
                Name
                <input
                  className="form-control form-control-sm"
                  value={clipLabel}
                  onChange={(e) => setClipLabel(e.target.value)}
                  placeholder="z. B. Schulportal"
                />
              </label>
              <label className="small mb-0 flex-grow-1">
                URL
                <input
                  className="form-control form-control-sm"
                  value={clipUrl}
                  onChange={(e) => setClipUrl(e.target.value)}
                  placeholder="https://"
                />
              </label>
              <button type="button" className="btn btn-sm btn-outline-primary" onClick={addWebClip}>
                Hinzufügen
              </button>
            </div>
            {webClips.length ? (
              <div className="teacher-modal__chips">
                {webClips.map((clip) => (
                  <button
                    key={clip.URL}
                    type="button"
                    className="teacher-modal__chip"
                    onClick={() => removeWebClip(clip.URL)}
                    title="Entfernen"
                  >
                    <span>{clip.Label || clip.URL}</span>
                    <FaTimes />
                  </button>
                ))}
              </div>
            ) : (
              <span className="small text-muted">Noch keine Webclips. Nach dem Erstellen im Layout platzieren.</span>
            )}
          </div>
          <HomeScreenLayoutEditor
            fields={fields}
            onChange={setFields}
            availableApps={installedApps}
            webclips={webClips}
            hideAllowlistOption
          />
        </div>
        <div className="teacher-modal__foot">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => {
              onApply?.(null);
              onClose?.();
            }}
          >
            Layout entfernen
          </button>
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Abbrechen</button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              const layout = {
                Dock: fields.Dock || [],
                Pages: fields.Pages?.length ? fields.Pages : [[]],
              };
              const clips = collectWebClipsFromLayout(layout, webClips);
              onApply?.({
                homeScreenLayout: layout,
                allowListedAppBundleIds: collectLayoutBundleIds(layout),
                blockedAppBundleIds: null,
                webClips: clips,
              });
              onClose?.();
            }}
          >
            Layout anwenden
          </button>
        </div>
      </div>
    </div>
  );
}
